import { useState, useEffect, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import Progress from './progress';

const Uploader = ({ uploadUrl }) => {

    const [isLoaded, setIsLoaded] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({});
    const [files, setFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadMessages, setUploadMessages] = useState([]);

    useEffect(() => {
        setTimeout(() => {
            setIsLoaded(true);
        }, 1000);
    }, []);

    const onDrop = useCallback((acceptedFiles) => {
        setUploadMessages([]);
        setIsUploading(true);

        acceptedFiles.forEach((file) => {
            handleUpload(file);
        });

    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    const handleUpload = (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const postHeaders = {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            'Authorization': 'Bearer ' + document.querySelector('meta[name="api-token"]').getAttribute('content')
        }

        axios.post(uploadUrl, formData, {
            headers: postHeaders,
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                setUploadProgress((prev) => {
                    return {
                        ...prev,
                        [file.name]: {
                            file_name: file.name,
                            percentage: percentCompleted
                        }
                    };
                });
            }
        }).then((response) => {

            setFiles((prev) => {
                return [
                    ...prev,
                    response.data
                ];
            });

            setUploadMessages((prev) => {
                return [
                    ...prev,
                    {
                        type: 'success',
                        message: `Bestand ${file.name} succesvol geüpload`
                    }
                ];
            });
        }).catch((error) => {
            setUploadMessages((prev) => {
                return [
                    ...prev,
                    {
                        type: 'danger',
                        message: `Fout bij uploaden van bestand ${file.name}`
                    }
                ];
            });
        }).finally(() => {
            setIsUploading(false);
        });
    }

    if (!isLoaded) {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Laden...</span>
                </div>
            </div>
        );
    }

    console.log(uploadProgress)

    return (
        <div className="container">
            <div
                {...getRootProps()}
                className={`dropzone p-5 border border-2 rounded d-flex flex-column align-items-center ${isDragActive ? 'bg-light border-primary' : 'bg-white border-secondary'}`}
                style={{cursor: 'pointer'}}
            >
                <input {...getInputProps()} />
                <i className="fa fa-cloud-upload-alt fa-3x mb-3" aria-hidden="true" style={{color: isDragActive ? '#3634a3' : '#6c757d'}}></i>
                {isDragActive ? (
                    <p className="text-primary">
                        Sleep de bestanden hier om ze te uploaden
                    </p>
                ) : (
                    <p className="text-secondary">
                        Sleep bestanden hierheen of klik om bestanden te selecteren
                    </p>
                )}
            </div>

            {Object.keys(uploadProgress).length > 0 && (
                <div className="container mt-4">
                    {Object.keys(uploadProgress).map((key) => (
                        <Progress key={key} progress={uploadProgress[key]} />
                    ))}

                </div>
            )}

            {files.length > 0 && (
                <>
                    <input type="hidden" name="file_count" value={files.length} />
                    {files.map((file) => (
                        <input type="hidden" key={file.file_name} name={'file_paths[' + file.file_name + ']'} value={file.path} />
                    ))}
                </>
            )}

        </div>
    )

}

export default Uploader;
